"use client";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, startTransition, use, useEffect, useState, } from "react";
import { CarrierMark } from "./carrier-mark.js";
var NO_MARKS = {};
var ProviderMarksContext = createContext(NO_MARKS);
export function ProviderMarksProvider(_a) {
    var _this = this;
    var apiUrl = _a.apiUrl, children = _a.children;
    var _b = useState(NO_MARKS), marks = _b[0], setMarks = _b[1];
    useEffect(function () {
        var controller = new AbortController();
        void (function () { return __awaiter(_this, void 0, void 0, function () {
            var res, data_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(apiUrl, "/internal/provider-marks"), {
                                signal: controller.signal,
                            })];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) {
                            throw new Error("HTTP ".concat(res.status));
                        }
                        return [4, res.json()];
                    case 2:
                        data_1 = (_a.sent());
                        startTransition(function () { return setMarks(data_1.marks); });
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        if (!controller.signal.aborted) {
                            console.warn("Provider marks unavailable:", error_1);
                        }
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); })();
        return function () { return controller.abort(); };
    }, [apiUrl]);
    return _jsx(ProviderMarksContext, { value: marks, children: children });
}
export function ProviderMark(_a) {
    var provider = _a.provider, className = _a.className, children = _a.children;
    var marks = use(ProviderMarksContext);
    var mark = Object.hasOwn(marks, provider) ? marks[provider] : undefined;
    return mark ? _jsx(CarrierMark, { src: mark, className: className }) : children;
}
//# sourceMappingURL=provider-marks.js.map